export const tableCellStyle = {
  general: {
    paddingLeft: "1rem",
    paddingRight: "1rem",
    paddingTop: ".5rem",
    paddingBottom: ".5rem"
  },
  header: { fontSize: "1.1rem" }
};
